'use strict';

import React from 'react';

import { CustomEvents } from '../../../../utils/customEvents';


const ListItemDetail = ({ element, event, item, detail }) => {
  const [duration, setDuration] = React.useState(0);
  React.useEffect(() => { if (item.object === 'service') { setDuration(item.duration) } }, []);

  const onclickEvent = () => {
    let eventDetail = item;
    if (item.object === 'service') {
      eventDetail.duration = duration;
    }

    // Trigger event listeners
    CustomEvents(element.id, event, eventDetail);
    
    // Clear inner HTML of List Element
    document.getElementById(element.id).innerHTML = '';
  }
  
  const textDetailColumns = detail.filter(d => d.text).map((d, i) => <div className='ListItemDetailColumn' onClick={onclickEvent} key={i}>{d.text}</div>);

  const dropdownColumn = detail.filter(d => d.dropdown)
                               .map((d, i) => 
                                 <select key={i} onChange={e => setDuration(parseInt(e.target.value))} className='ListItemDropdown'>
                                   {d.dropdown.options?.map((o, oI) => <option key={oI} value={o.value}>{o.text}</option>)}
                                 </select>
                               )

  return (
    <div className='ListItemDetail onsched-dark-color noselect'>  
      { textDetailColumns }

      { dropdownColumn }
    </div>
  )
}

export default ListItemDetail;
